<brd-functionalities-grid
  [selectedRowKeys]="selectedFunctionalities"
  (selectionChanged)="selectionChanged($event)"
  [customItems]="customToolbarItems"
></brd-functionalities-grid>
